import { ICurrencyEntityReference, IPhotoEntityReference } from '../../../basic';
import { IUiButtonSettings } from '../../../configs/ui-elements';
import { GsStructComponent } from '../component';
import { CustomerLoyaltyMode } from './debit-card-detail-component';

/** Mirrors the backend enum `DebitCardLoyaltyLevel`. */
export enum DebitCardLoyaltyLevel {
  Basis = 0,
  Bronze = 1,
  Silver = 2,
  Gold = 3
}

/** A single level of the loyalty club */
export interface IDebitCardLoyaltyLevel {
  /** The level the entry stands for */
  level: DebitCardLoyaltyLevel;
  /** Value the level starts at, empty for the lowest level */
  from?: number;
  /** Value the level ends at, empty when the level is open ended */
  to?: number;
  /** Whether the member has reached the level */
  reached: boolean;
  /** Whether the level is the current status of the member */
  current: boolean;
  /** Points or turnover missing up to the level, empty for reached levels */
  missing?: number;
  /** Benefits of the level, one entry per line */
  benefits: string[];
  /** Picture of the level that hangs on its newsletter group, empty when none is set */
  picture?: IPhotoEntityReference;
}

/** Data the backend renders for the DebitCardLoyaltyStatus component */
export interface IDebitCardLoyaltyStatusRender {
  /** Customer loyalty mode the debit card settings are running in */
  loyaltyMode: CustomerLoyaltyMode;
  /** Points or turnover of the debit card */
  value: number;
  /** Currency of `value`, only relevant in the turnover loyalty mode */
  currency?: ICurrencyEntityReference;
  /** Share of `value` in the `to` of the current level, 0 to 100. Counts from 0, not from `from` */
  percent: number;
  /** The current level of the member */
  currentLevel: DebitCardLoyaltyLevel;
  /** The level above the current one, empty in the highest level */
  nextLevel?: DebitCardLoyaltyLevel;
  /** All levels of the loyalty club, ascending. Empty while the levels are not set up */
  levels: IDebitCardLoyaltyLevel[];
  /** Link to the page that holds the points history, empty when no such page exists */
  historyLink?: string;
}

/** Structure definition for the DebitCardLoyaltyStatus component. */
export interface GsStructDebitCardLoyaltyStatusComponent extends GsStructComponent<IDebitCardLoyaltyStatusRender> {
  /** The specified type-key for this struct */
  componentType: 'DebitCardLoyaltyStatus';
  /** Whether all levels with their benefits are shown below the progress wheel */
  showMoreInfos?: boolean;
  /** Button styling overrides for this component */
  buttons?: IUiButtonSettings;
}
